import React, {  Component } from 'react';

export default class ConfirmDeleteUserDialogSuccess extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('ConfirmDeleteUserDialogSuccess', false);
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="emailSpecOverlayDialog1">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Success</h2>
                    <p>User Deleted Successfully</p>
                    <form className="emailSpecForm" onSubmit={this.closeDialog.bind(this)}>
                       <div className="floatRight">
                          <input className="blueButton" type="submit" value="OK" />
                       </div>
                       <div className="clear" />
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/confirmDeleteUserDialogSuccess.js